export enum SessionStatus {
  Processing = 'processing',
  Solving = 'solving',
  Completed = 'completed',
  Failed = 'failed',
}

export const TERMINAL_STATUSES: SessionStatus[] = [SessionStatus.Completed, SessionStatus.Failed];

export interface RoreScore {
  hardScore: number;
  mediumScore: number;
  softScore: number;
}

export interface RoreAppointment {
  id: string;
  date: string;
  start_time: string;
  end_time: string;
  user_id?: string;
  pinned?: boolean;
  [key: string]: unknown;
}

export interface RoreUser {
  id: string;
  name: string | null;
  photo_path_1: string | null;
  qualifications: number[] | null;
  appointments: RoreAppointment[];
  [key: string]: unknown;
}

export interface RoreSessionError {
  code: string;
  message: string;
}

export interface RoreSession {
  session_id: string;
  status: SessionStatus;
  created_at: string;
  started_at?: string;
  completed_at?: string;
  score?: RoreScore | null;
  users?: RoreUser[];
  error?: RoreSessionError;
}
